var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home m-4 flex"},[_c('rp-card',{staticClass:"mx-auto bg-opacity-50 no-border"},[_c('h1',{staticClass:"text-4xl font-bold"},[_vm._v("Bienvenue dans la boutique")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }